import React, { Component } from "react";

import DesktopNavigation from "./desktop-navigation";
import MobileNavigation from "./mobile-navigation";
import CommToolContext from "../common/comm_tool_context";

class Navigation extends Component {

  render() {
    return (
        <CommToolContext.Consumer>
            {context =>
                (
          // <nav id="app-nav" style={{ width: "90%", margin: "0 auto" }}>
                  <nav id="app-nav" style={{ width: "97%", margin: "0 auto"}}> 

        <div id="desktop-nav">
          <DesktopNavigation {...this.props} context={context}/>
        </div>
        <div id="mobile-nav">
          <MobileNavigation {...this.props}/>
        </div>
      </nav>
                )}
        </CommToolContext.Consumer>
    );
  }
}

export default Navigation;